<div *ngIf="showLoader" class="loading-model property">
  <p-progress-spinner></p-progress-spinner>
</div>
<div class="add-button-wrapper" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <p-button type="button" label="Add Lookup" icon="pi pi-plus" (onClick)="addLookupTemplate()" class="new-btn" *ngIf="!disableField"/>
</div>
<p-accordion
  [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }"
  [value]="selected"
  (valueChange)="selected = $event"
  *ngIf="lookupTemplates.length > 0"
  [expandIcon]="'pi pi-chevron-down'"
  [collapseIcon]="'pi pi-chevron-up'"
  [transitionOptions]="'300ms cubic-bezier(0.4, 0, 0.2, 1)'"
>
  <p-accordion-panel
    *ngFor="let lookup of lookupTemplates | uiFilter: searchTerm : ['name']; let i = index; trackBy: trackByLookup"
    [value]="lookup?.sid"
    class="border-class"
    [ngClass]="{ 'bor-err': lookup.err }"
  >
      <p-accordion-header>
        <div class="header-delete-icon-wrapper">
          <div class="imp-header-wrapper">
            <div class="imp-header">{{ lookup.name }}</div>
          </div>
        <div
          class="del-icon-wrapper d-flex"
          [ngClass]="{ disableField: disableField }"
        >
          <button
            (click)="showWhereUsed($event, i)"
            *ngIf="lookup.name"
            type="button"
            class="where-used-icon-for-overlay"
            aria-hidden="true"
            showDelay="100"
            hideDelay="100"
            [disabled]="disableField"
            pTooltip="{{ 'WHERE_USED' | translate }}"
            tooltipPosition="top"
          >
            <svg-icon [src]="svgPaths.whereUsed.default"></svg-icon>
          </button>

          <button
            (click)="delLookup($event, i)"
            *ngIf="lookup.name"
            type="button"
            class="delete-icon"
            aria-hidden="true"
            showDelay="100"
            hideDelay="100"
            [disabled]="disableField"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="Delete"
            tooltipPosition="top"
          >
            <svg-icon src="assets\images\svg\trash.svg"></svg-icon>
          </button>
        </div>
      </div>
    </p-accordion-header>

    <p-accordion-content>
      <div class="position-relative row form-group prop-elems">
        <label class="col-sm-6 col-form-label" [for]="'impname-' + i"
          >{{ 'LOOKUP_TEMP_NAME' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_NAME_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0">
          <input
            [name]="lookup.name"
            id="impname-{{ i }}"
            type="text"
            maxlength="64"
            [(ngModel)]="lookup.name"
            [ngClass]="{ 'bor-err': lookup.err }"
            (focusout)="onNameChange($event, lookup)"
            [disabled]="disableField"
            class="form-control form-control-sm"
          />
        </div>
      </div>

      <div class="position-relative row form-group prop-elems" *ngIf="formData.t_type !== 'query_view'">
        <label class="col-sm-6 col-form-label" [for]="'index-' + i"
          >{{ 'INDEX' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_INDEX_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0">
          <p-select
            [options]="indices"
            placeholder="Select"
            optionLabel="indexName"
            optionValue="sid"
            appendTo="body"
            [(ngModel)]="lookup.index"
            class="form-control form-control-sm"
            (onChange)="trigerGetRef('INDEX_UPDATE', 'UPDATE', lookup, $event)"
            [inputId]="'index-' + i"
            [disabled]="disableField"
          >
          </p-select>
        </div>
      </div>
      <div class="position-relative row form-group prop-elems" *ngIf="formData.t_type !== 'query_view'">
        <label class="col-sm-6 col-form-label" [for]="'displayField-' + i"
          >{{ 'DIS_FLD' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_DIS_FLD_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0">
          <div class="section-table-container w-100 lookup-tbl">
            <p-table
              [value]="lookup.displayField"
              class="fil-map-table"
              styleClass="p-datatable-gridlines"
              [style]="{ width: '100%' }"
              [scrollable]="true"
              [id]="'displayField-' + i"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'REF_FLD' | translate }}</th>
                  <th>{{ 'DIS_FLD' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-data let-ri="rowIndex">
                <tr>
                  <td>
                    <span [pTooltip]="getFieldLabel(data.referenceField)" tooltipPosition="bottom">{{
                      getFieldLabel(data.referenceField)
                    }}</span>
                  </td>
                  <td class="hover-icon-cell">
                    <div class="d-flex align-items-center lookupDef">
                      <div
                        class="custom-icon-wrapper"
                        [ngClass]="{
                          'warning-border': hasWarning(lookup.sid, data),
                          'error-border': hasError(lookup.sid, data)
                        }"
                      >
                        <p-autocomplete
                          [(ngModel)]="data.displayField"
                          [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                          (completeMethod)="showFilteredOptions(data.referenceField)"
                          [suggestions]="allFieldsFiltered"
                          [showEmptyMessage]="true"
                          (onSelect)="trigerGetRef('DIS_UPDATE', 'UPDATE', lookup, $event)"
                          trim="blur"
                          appendTo="body"
                          [dropdown]="true"
                          [forceSelection]="true"
                          field="name"
                          placeholder="Select"
                          [pTooltip]="getFieldLabel(data.displayField)"
                          tooltipPosition="bottom"
                          [disabled]="disableField"
                        >
                        </p-autocomplete>
                        <span *ngIf="hasWarning(lookup.sid, data)">
                          <i
                            class="pi pi-exclamation-triangle warning-icon"
                            tabindex="0"
                            (mouseenter)="toggleWarningPopup($event, lookup, data)"
                            (mouseleave)="toggleWarningPopup($event, lookup, data)"
                          ></i>
                        </span>

                        <span *ngIf="hasError(lookup.sid, data)">
                          <i
                            class="pi pi-exclamation-circle error-icon-1"
                            tabindex="0"
                            (mouseenter)="toggleWarningPopup($event, lookup, data)"
                            (mouseleave)="toggleWarningPopup($event, lookup, data)"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr class="no-records">
                  <td colspan="2" class="text-center">
                    {{ 'NO_RECORDS_FOUND' | translate }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <p-popover #popover>
        <div
          class="val-err"
          [ngClass]="{
            'error-popup': hasError(activeLookup?.sid, activeRow),
            'warning-popup': hasWarning(activeLookup?.sid, activeRow)
          }"
        >
          <div class="warning-header">
            <p *ngIf="hasWarning(activeLookup?.sid, activeRow)">Warning</p>
            <p *ngIf="hasError(activeLookup?.sid, activeRow)">Error</p>
          </div>
          {{ errorMsg }}
        </div>
      </p-popover>
      <div class="position-relative row form-group prop-elems" *ngIf="formData.t_type === 'query_view'">
        <label class="col-sm-6 col-form-label" [for]="'displayFieldForQueryView-' + i"
          >{{ 'DIS_FLD' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_DIS_FLD_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0">
          <p-multiselect
            id="displayFieldForQueryView-{{ i }}"
            resetFilterOnHide="true"
            [options]="displayFieldForQueryView"
            display="chip"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [filter]="true"
            filterBy="label"
            [(ngModel)]="lookup.displayFieldForQueryView"
            [disabled]="disableField"
            class="form-control form-control-sm input-number-format-wrapper"
            placeholder="Select"
            [disabled]="disableField"
            (onChange)="trigerGetRef('DIS_UPDATE', 'UPDATE', lookup, $event)"
          >
          </p-multiselect>
        </div>
      </div>
      <div class="position-relative row form-group prop-elems" *ngIf="formData.t_type !== 'query_view'">
        <label class="col-sm-6 col-form-label" [for]="'inputFilters-' + i"
          >{{ 'INP_FIL_FLDS' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_INP_FILS_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0 d-flex">
          <div class="p-inputgroup pl-2">
            <div class="fields" [id]="'inputFilters-' + i">
              <span *ngFor="let field of lookup.inputFilters; trackBy: trackByField" class="field-name mr-1">
                {{ field.altName ? field.altName : fieldIdMap[field] }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="position-relative row form-group prop-elems" *ngIf="formData.t_type !== 'query_view'">
        <label class="col-sm-6 col-form-label" for="lookupFields"
          >{{ 'OUT_FLDS' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_OUT_FLS_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0 d-flex" [ngClass]="{ 'error-border': isOutputFieldInvalid(lookup) }">
          <div class="p-inputgroup pl-2">
            <div id="lookupFields" class="fields">
              <span *ngFor="let field of lookup.fields; trackBy: trackByField" class="field-name mr-1">
                {{ getFieldLabel(field) }}
              </span>
            </div>
            <span class="p-inputgroup-addon">
              <i
                class="pi pi-exclamation-circle error-icon-1 output-field-error-icon"
                *ngIf="isOutputFieldInvalid(lookup)"
                (mouseenter)="toggleOutputFieldInvalidPopup(lookup)"
                (mouseleave)="toggleOutputFieldInvalidPopup(lookup)"
              ></i>
              <button type="button" class="p-element p-component p-button-icon-only" title="Reorder" [disabled]="disableField">
                <i
                  class="pi pi-pencil"
                  (click)="togglePickList($event, lookup, 'fields')"
                  (keyup.enter)="togglePickList($event, lookup, 'fields')"
                  tabindex="0"
                ></i>
              </button>
            </span>
          </div>
        </div>

        <div class="warning-wrapper" *ngIf="isOutputFieldInvalidPopupVisible(lookup)">
          <div class="error-popup val-err">
            <div class="warning-header">
              <p>Error</p>
              <i class="pi pi-times"></i>
            </div>
            {{ errorMsg }}
          </div>
        </div>
      </div>

      <div class="position-relative row form-group prop-elems" *ngIf="formData.t_type === 'query_view'">
        <label class="col-sm-6 col-form-label" [for]="'outFields-' + i"
          >{{ 'OUT_FLDS' | translate }}
          <i
            class="fa fa-info-circle field-info"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'LK_OUT_FLS_INFO' | translate }}"
          ></i>
        </label>
        <div class="col-sm-6 input-ctrl pl-0">
          <p-multiselect
            id="outFields-{{ i }}"
            resetFilterOnHide="true"
            [options]="fields"
            display="chip"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [filter]="true"
            filterBy="label"
            [(ngModel)]="lookup.fields"
            class="form-control form-control-sm input-number-format-wrapper"
            placeholder="Select"
            [disabled]="disableField"
            (onChange)="trigerGetRef('DIS_UPDATE', 'UPDATE', lookup, $event)"
          >
          </p-multiselect>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>

<p-dialog
  [(visible)]="showPickList"
  [modal]="true"
  (onHide)="closeDialog($event)"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '60vw' }"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      {{ tableName }} - {{ 'SELECT_REORDER_LOOKDEF' | translate }} :
      <span class="dialog-subheader">{{ currentTemplate.name }}</span>
    </div>
  </ng-template>
  <p-picklist
    [source]="source"
    [target]="target"
    [responsive]="true"
    sourceHeader="Available Fields"
    targetHeader="Selected Fields"
    filterBy="name"
    sourceFilterPlaceholder="Search by name"
    (onTargetSelect)="ontargetSelect($event)"
    targetFilterPlaceholder="Search by name"
    (onTargetReorder)="onTargetReorder($event)"
    (onMoveToTarget)="onMoveToTarget($event)"
    (onMoveAllToTarget)="onMoveToTarget($event)"
    (onMoveToSource)="onMoveToSource($event)"
    (onMoveAllToSource)="onMoveToSource($event)"
    [disabled]="disableField"
    *ngIf="showPickList"
  >
    <ng-template let-property #item>
      <div class="property-detail" (dblclick)="handleDoubleClick(property)">
        <div class="d-flex align-items-center justify-content-between">
          <div class="header">
            <div [ngClass]="{ 'sub-text mt-1': property.altName }">{{ getFieldLabel(property) }}</div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #emptymessagesource>
      <div class="property-detail text-center">
        <span>No Fields Available</span>
      </div>
    </ng-template>
    <ng-template #emptymessagetarget>
      <div class="property-detail text-center">
        <span>No Fields Available</span>
      </div>
    </ng-template>
  </p-picklist>
  <div *ngIf="showLoader" class="loading-model property">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog($event)">
      {{ 'CANCEL' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="trigerGetRef('FLDS_UPDATE', 'UPDATE', currentTemplate, $event)"
      [disabled]="disableField"
    >
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
</p-dialog>
